export const firebaseConfig = {
  apiKey: 'AIzaSyByw9v98L2mz4KCZ2t8vR9VDSs9LePGCCc',
  authDomain: 'zubaidi-reg-2018.firebaseapp.com',
  databaseURL: 'https://zubaidi-reg-2018.firebaseio.com',
  projectId: 'zubaidi-reg-2018',
  storageBucket: 'zubaidi-reg-2018.appspot.com',
  messagingSenderId: '528623741324'
};
